import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { href: '#inicio', label: 'Início' },
    { href: '#funcionalidades', label: 'Funcionalidades' },
    { href: '#como-funciona', label: 'Como Funciona' },
    { href: '/signup', label: 'Criar Conta' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-cream-50/95 backdrop-blur-sm border-b border-cream-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="/santogram_logo.png"
              alt="SantoGram Logo"
              className="w-16 h-16 md:w-20 md:h-20 object-contain"
            />
          </div>

          {/* Desktop Menu */}
          <nav className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-brown-700 hover:text-gold-600 font-semibold transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
            <a
              href="/signin"
              className="px-6 py-2 bg-gold-500 text-white hover:bg-gold-600 font-semibold rounded-lg transition-colors duration-200"
            >
              Acessar Conta
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-brown-700 hover:text-gold-600 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-cream-200 pt-4">
            <div className="flex flex-col space-y-3">
              {menuItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-brown-700 hover:text-gold-600 font-semibold transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="/signin"
                className="px-6 py-2 bg-gold-500 text-white hover:bg-gold-600 font-semibold rounded-lg transition-colors duration-200 text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                Acessar Conta
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header; 